import i18n from "../../Localization/i18n";

const BUNDLES = {
  en: {
    notifications: {
      default: "Notification",
      success: "Success",
      error: "Something went wrong",
      warning: "Heads up",
      info: "Notice",
      loading: "Working on it",
      dismiss: "Dismiss",
    },
  },
  "ar-AE": {
    notifications: {
      default: "إشعار",
      success: "تم بنجاح",
      error: "حدث خطأ ما",
      warning: "تنبيه",
      info: "ملاحظة",
      loading: "جارٍ المعالجة",
      dismiss: "إغلاق",
    },
  },
};

let registered = false;

export const ensureToastMessages = () => {
  if (registered || !i18n || typeof i18n.addResourceBundle !== "function") return;
  Object.entries(BUNDLES).forEach(([lng, bundle]) => {
    // deep merge, never overwrite keys the app already defines
    i18n.addResourceBundle(lng, "translation", bundle, true, false);
  });
  registered = true;
};

export const toastTitle = (type) => {
  ensureToastMessages();
  const fallback = BUNDLES.en.notifications[type] || BUNDLES.en.notifications.default;
  return i18n.t(`notifications.${type}`, { defaultValue: fallback });
};

export const toastDismissLabel = () => {
  ensureToastMessages();
  return i18n.t("notifications.dismiss", { defaultValue: BUNDLES.en.notifications.dismiss });
};
